import { ForbiddenError } from "../errors.js";
export function isStaff(ctx) {
    return ctx.role === "admin" || ctx.role === "employee";
}
function unauthorized(query) {
    return query.where("id", "__unauthorized__");
}
/**
 * Restricts a query over a project-scoped table to the projects the caller
 * may read. `projectField` is the column holding the project id.
 */
export function scopeToReadableProjects(ctx, query, projectField = "projectID") {
    if (isStaff(ctx))
        return query;
    if (ctx.role !== "freelancer")
        return unauthorized(query);
    if (ctx.clientSide)
        return query;
    const ids = ctx.readableProjectIDs ?? [];
    if (ids.length === 0)
        return unauthorized(query);
    return query.where(projectField, "IN", [...ids]);
}
export function canReadProject(ctx, projectID) {
    if (isStaff(ctx))
        return true;
    if (ctx.role !== "freelancer" || !projectID)
        return false;
    if (ctx.clientSide)
        return true;
    return (ctx.readableProjectIDs ?? []).includes(projectID);
}
export function canEditProject(ctx, projectID) {
    if (isStaff(ctx))
        return true;
    if (ctx.role !== "freelancer" || !projectID)
        return false;
    if (ctx.clientSide)
        return true;
    return (ctx.editableProjectIDs ?? []).includes(projectID);
}
/** Throws unless the caller may edit data of the given project. */
export function assertCanEditProject(ctx, projectID) {
    if (!canEditProject(ctx, projectID)) {
        throw new ForbiddenError("Not allowed to edit this project");
    }
}
